import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../helper/analytics";
import { trackRegistrationStepViewed } from "../../helper/registrationAnalytics";

/**
 * Tracks SPA route changes for GA4 page views and registration step views.
 * Uses pathname only — query strings are never sent to analytics.
 */
const AnalyticsRouteTracker = () => {
  const location = useLocation();
  const previousPathRef = useRef(null);

  useEffect(() => {
    const pathname = location.pathname;

    if (previousPathRef.current === pathname) {
      return;
    }

    previousPathRef.current = pathname;
    trackPageView(pathname);
    trackRegistrationStepViewed(pathname);
  }, [location.pathname]);

  return null;
};

export default AnalyticsRouteTracker;
